import { useLanguage } from "../../../../../../../context/LanguageContext";
import { useAdminProductsTranslation } from "../../../../translations";

export const DateRangeInputs = ({
    startDate,
    endDate,
    onStartDateChange,
    onEndDateChange
}) => {
    const { language } = useLanguage();
    const { t } = useAdminProductsTranslation(language);

    return (
        <div className="form-row">
            <div className="form-group">
                <label>{t('startDate')}</label>
                <input
                    type="date"
                    value={startDate}
                    onChange={(e) => onStartDateChange(e.target.value)}
                    required
                />
            </div>

            <div className="form-group">
                <label>{t('endDate')} (Optional)</label>
                <input
                    type="date"
                    value={endDate}
                    onChange={(e) => onEndDateChange(e.target.value)}
                    min={startDate}
                />
            </div>
        </div>
    );
};

// Exporting the component
export default DateRangeInputs;